import {SoilTranslationsType} from './SoilsTranslationsType';

export const soilsTranslationsEs: SoilTranslationsType = {
  'soils.validation.min': 'Debe ser superior a 0',
  'soils.validation.max': 'Debe ser inferior a 1',
  'soils.validation.rfu_ru': 'Este campo es obligatorio',
  'soils.edit.rfu.error': 'Valor inválido',
  'soils.table.rfu_ru': 'AFA/HA',
  'arvalis.modal.title': 'Configure su AFA/HA con la ayuda de ARVALIS',
  'arvalis.modal.button.label': 'Simulador de ARVALIS',
  'soil.arvalis-modal.button.label': '¿Cómo configurar mi suelo si no tengo un análisis completo?',
  'arvalis.modal.text1':
    '¿No conoce su AFA/HA con precisión? Haga clic en el simulador desarrollado por ARVALIS que le ayudará a definirlos en función de algunos criterios. Esto le permitirá mejorar la fiabilidad de las recomendaciones de riego de Pixagri a lo largo de la campaña.',
  'arvalis.modal.text2':
    'Luego ingrese el valor de RU y la proporción AFA/HA al crear su suelo. También asegúrese de seleccionar la textura más cercana a su suelo.',
};
